import axios from 'axios';

const adminAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

adminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminAccessToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

adminAxiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url !== "admin/login" && err.response?.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;
      try {
        const refreshToken = localStorage.getItem('adminRefreshToken');
        if (!refreshToken) {
            localStorage.removeItem("adminAccessToken");
            localStorage.removeItem("adminRefreshToken");
            localStorage.removeItem("admin-email-golden");
            window.location.href = '/';
            return Promise.reject(err);
        }
        
        const rs = await axios.post(`${process.env.REACT_APP_API_BASE_URL}auth/refresh`, {
          refreshToken: refreshToken,
        });

        const { accessToken, refreshToken: newRefreshToken } = rs.data;
        localStorage.setItem('adminAccessToken', accessToken);
        localStorage.setItem('adminRefreshToken', newRefreshToken);
        
        return adminAxiosInstance(originalConfig);
      } catch (_error) {
        localStorage.removeItem("adminAccessToken");
        localStorage.removeItem("adminRefreshToken");
        localStorage.removeItem("admin-email-golden");
        window.location.href = '/';
        return Promise.reject(_error);
      }
    }
    return Promise.reject(err);
  }
);

export default adminAxiosInstance;